import React from "react";
import { Link } from "react-router-dom";
import './Footer.css';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section logo">
            <Link to="/">
              <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="Logo" />
            </Link>
            <p>We are committed to providing high-quality services and solutions to meet all your needs. Our experienced team ensures excellence in every project.</p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/clients">Clients</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/team">Team</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section contact">
            <h3>Contact Details</h3>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <span>+91 12345 67890</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <span>info@company.com</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <span>City, Country</span>
              </div>
            </div>
          </div>

          <div className="footer-section social">
            <h3>Connect With Us</h3>
            <div className="socials">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
            </div>
            <div className="footer-newsletter">
              <h4>Subscribe to Newsletter</h4>
              <form>
                <input type="email" placeholder="Enter your email" />
                <button type="submit"><i className="fas fa-paper-plane"></i></button>
              </form>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-bottom">
        {/* <p>&copy; {new Date().getFullYear()} Company Name. All Rights Reserved.</p> */}
        <p>Designed by <a href="/" className="company-link">Your Company</a></p>
      </div>
    </>
  );
};

export default Footer;